/**
 * APIエラーの基底クラス
 */
export abstract class ApiError extends Error {
  override name = 'ApiError';
  /** ステータスコード（HTTPステータスコードとは別） */
  status: string;
  /** エラーID（ログトレース用のUUID） */
  errorId: string;
  /** 画面ID */
  displayId: string;

  constructor(status: string, message: string, errorId: string, displayId: string) {
    super();
    this.status = status;
    this.message = message;
    this.errorId = errorId;
    this.displayId = displayId;
  }
}
